import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";
import { Topbar } from "../Topbar/Topbar";

export const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen w-screen bg-lyrax-bg overflow-x-hidden overflow-y-hidden">
      <Sidebar collapsed={collapsed} />

      <div className="flex flex-col flex-1 min-w-0 p-2 sm:p-3 pl-0 overflow-hidden">
        <div className="flex flex-col flex-1 min-h-0 rounded-[1.25rem] bg-lyrax-bg overflow-hidden shadow-lyrax">
          <Topbar onToggleSidebar={() => setCollapsed(!collapsed)} />
          <main className="flex-1 overflow-y-auto p-5 sm:p-6 lg:p-8">
            <div className="max-w-[1600px] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
